
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M12.4 50.46V1.87h5.5v48.59M10.12 50.98h10v7.15h-10zM42.11 50.46V1.87h5.5v48.59M39.86 50.98h10v7.15h-10z"}}),_c('path',{attrs:{"d":"M42.13 6.49A12.25 12.25 0 0130 18.89a12.25 12.25 0 01-12.1-12.4M60 18.89a12.47 12.47 0 01-12.38-12.4M0 18.89a12.47 12.47 0 0012.4-12.4M17.7 34.83h24.6M46.94 34.83h13.04M.02 34.83h12.95M25.42 17.89v17.2M34.64 17.89v17.2M55.14 17.79v17.3M4.82 17.79v17.3","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    